import { useItemStock } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import { getStockStatusIndicatorColor } from "@coworker/app/src/components/RoomSettings/Molecules/ArticleStock.helper";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./item-stock.module.css";
import React from "react";

interface ItemStockProps {
  itemNo: string;
  itemType: string;
}

export const ItemStock = ({ itemNo, itemType }: ItemStockProps) => {
  const { data: itemStockInfo, isLoading: isLoadingItemStockInfo } =
    useItemStock(itemType, itemNo);

  const stockStatusColor = getStockStatusIndicatorColor(
    itemStockInfo?.available,
    itemStockInfo?.elevated
  );

  const elevatedStatus = !itemStockInfo?.elevated
    ? "(0)"
    : `(${itemStockInfo?.elevated})`;
  return (
    <React.Fragment>
      {isLoadingItemStockInfo && <FixaSkeleton width="100%" height="16px" />}
      {!isLoadingItemStockInfo && itemStockInfo && (
        <FixaStatus
          className={styles["item-stock-container"] || ""}
          label={`${itemStockInfo?.available} ${elevatedStatus}`}
          statusColor={stockStatusColor}
          small
        />
      )}
    </React.Fragment>
  );
};
